import { useEffect,useRef,useState } from "react";
import { useSelector } from "react-redux";
import VideoHighlight from "../VideoHighlight/VideoHighlight.js";
import logo from "../../assets/logo.png";
import { selectVar } from "../../store/conf/confSlice.js";

const Modal = ({ open,onClose,children }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center">
      <div className="relative w-full h-full flex items-center justify-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 text-white text-3xl leading-none"
          aria-label="Chiudi"
        >
          ✕
        </button>
        <div className="w-full h-full">
          {children}
        </div>
      </div>
    </div>
  );
};

const TopFiveSliderDisplay = ({ videos }) => {
  const [selectedVideo,setSelectedVideo] = useState(videos[0]);
  const [modalOpen,setModalOpen] = useState(false);
  const [showTrailer,setShowTrailer] = useState(false); // <<==== QUI !!!
  const ribbonRef = useRef(null);
  const timerRef = useRef();

  const timeVar = useSelector(selectVar("_TIME_SLIDESHOW", 6000));
  const intervalMs = Math.max(1000, Number(timeVar) || 6000);

  useEffect(() => {
    if (modalOpen || videos.length < 2) {
      clearInterval(timerRef.current);
      return;
    }
    timerRef.current = setInterval(() => {
      setShowTrailer(false); // reset trailer se stava partendo
      setSelectedVideo((prev) => {
        const currentIndex = videos.findIndex((v) => v.id === prev.id);
        const nextIndex = (currentIndex + 1) % videos.length;
        scrollToVideo(videos[nextIndex]);
        return videos[nextIndex];
      });
    }, intervalMs);
    return () => clearInterval(timerRef.current);
  },[videos, modalOpen, intervalMs]);

  const handleClick = (video) => {
    setSelectedVideo(video);
    setShowTrailer(true); // resetta sempre quando apri modale
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setShowTrailer(false); // chiudendo modale, chiudi anche trailer
  };

  const scrollToVideo = (video) => {
    const index = videos.findIndex((v) => v.id === video.id);
    const el = ribbonRef.current?.children[index];
    if (el && ribbonRef.current) {
      const containerWidth = ribbonRef.current.offsetWidth;
      const elLeft = el.offsetLeft;
      const elWidth = el.offsetWidth;
      if (elLeft < ribbonRef.current.scrollLeft) {
        ribbonRef.current.scrollTo({ left: elLeft,behavior: "smooth" });
      } else if (
        elLeft + elWidth >
        ribbonRef.current.scrollLeft + containerWidth
      ) {
        ribbonRef.current.scrollTo({
          left: elLeft + elWidth - containerWidth,
          behavior: "smooth",
        });
      }
    }
  };

  useEffect(() => {
    scrollToVideo(selectedVideo);
  },[selectedVideo]);

  return (
    <div className="relative">
      {/* Titolo sopra l'immagine */}
      <div className="absolute bottom-12 left-4 right-4 z-20 pointer-events-none text-left">
        <h3 className="font-montserrat text-white text-2xl sm:text-4xl md:text-5xl font-black drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)] line-clamp-2">
          {selectedVideo?.title || ''}
        </h3>
      </div>

      <VideoHighlight
        video={selectedVideo}
        onClick={() => handleClick(selectedVideo)}
      />
      <div className="absolute bottom-4 left-0 right-0 flex justify-center items-center gap-2 z-50">
        {videos.map((video) => (
          <span
            key={video.id}
            className={`h-2 w-2 rounded-full transition-all duration-300 ${selectedVideo.id === video.id
              ? "bg-white scale-125"
              : "bg-white/40"
              }`}
          />
        ))}
      </div>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <div className="relative w-full h-full">
          {/* Titolo anche nella modale, sopra al contenuto */}
          <div className="absolute bottom-12 left-8 right-8 z-20 pointer-events-none text-left">
            <h3 className="font-montserrat text-white text-4xl md:text-6xl font-black drop-shadow-[0_3px_10px_rgba(0,0,0,0.9)] line-clamp-2">
              {selectedVideo?.title || ''}
            </h3>
          </div>
          <VideoHighlight
            video={selectedVideo}
            showTrailer={showTrailer}
            onCloseTrailer={() => setShowTrailer(false)}
            onClick={() => setShowTrailer(true)}
            fullScreen
          />
        </div>
      </Modal>

      {/* Logo in basso a destra dello slideshow */}
      <div className="absolute bottom-4 right-4 z-20 pointer-events-none select-none w-28 sm:w-32 md:w-36">
        <div className="relative">
          <img
            src={logo}
            alt="Logo"
            className="w-full opacity-80"
            draggable={false}
          />
          <div className="absolute inset-x-0 bottom-0 h-[2px]" />
        </div>
      </div>
    </div>
  );
};

export default TopFiveSliderDisplay;
